import { Datagrid, FunctionField, ListContextProvider, TextField, useList, useRecordContext } from 'react-admin';
import { Accordion, AccordionDetails } from '@mui/material';
import { palette } from 'src/Theme';
import { Hospital } from '../Employees/types';

export const HospitalsListGridStyle = {
    '& .MuiTableRow-root.MuiTableRow-head > .MuiTableCell-head.RaDatagrid-expandHeader': {
        paddingLeft: '0px'
    },
    '& .RaDatagrid-expandedPanel > .MuiTableCell-root': {
        padding: '0px',
        borderBottom: 'none',
        '& .MuiAccordion-root': {
            boxShadow: 'none'
        }
    }
};

/**
 * Renders the Hospitals List
 */
export const HospitalsList: React.FC = () => {
    const record = useRecordContext();

    if (!record) return null;

    //TODO: check if it is working after adding hospitals to the center

    const hospitals = record.hospitals || [];
    const listContext = useList({ data: hospitals, sort: { field: 'name', order: 'ASC' } });

    return (
        <Accordion disableGutters>
            <AccordionDetails sx={{ padding: '0' }}>
                <ListContextProvider value={listContext}>
                    <Datagrid
                        bulkActionButtons={false}
                        sx={{
                            '.RaDatagrid-headerCell': {
                                color: palette.primary.midnightBlue
                            },
                            '.RaDatagridHeaderCell-icon.MuiTableSortLabel-icon': {
                                display: 'initial'
                            }
                        }}>
                        <TextField label="" source="" />
                        <TextField label="Назва лікарні" source="name" />
                        <TextField label="Місто" source="city" />
                        <TextField label="Адреса" source="address" />
                        <FunctionField
                            label="Робочі години"
                            render={(record: Hospital) => `${record.workStart} – ${record.workEnd}`}
                        />
                        <FunctionField
                            label="Перерва на обід"
                            render={(record: Hospital) => `${record.breakStart} – ${record.breakEnd}`}
                        />
                    </Datagrid>
                </ListContextProvider>
            </AccordionDetails>
        </Accordion>
    );
};
